import React, {useState, useEffect} from 'react';
import http from "../http/http";
import swal from "../utils/swal"

const useCities = (parentSelectedCity, parentSelectedDistrict) => {
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState();
    const [selectedDistrict, setSelectedDistrict] = useState();
    const [districts, setDistricts] = useState([]);
    //todo show alerts in catch

    const getCities = () => {
        return http.get("/lookup/country/1/cities")
            .then((response) => {
                setCities(response.data);
            }).catch((e) => {
                // swal("something went wrong")
            });
    }
    const getDistricts = (cityId) => {
        http.get(`/lookup/country/1/city/${cityId}/districts`)
            .then((response) => {
                setDistricts(response.data);
            })
            .catch((e) => {
            });
    }

    useEffect(() => {
        getCities()
            .then(() => {
                if (parentSelectedCity && parentSelectedDistrict) {
                    setSelectedCity(parentSelectedCity); // fired the useEffect below
                    setSelectedDistrict(parentSelectedDistrict);
                }
            });
    }, [parentSelectedCity, parentSelectedDistrict]);

    useEffect(() => {
        if (selectedCity) {
            getDistricts(selectedCity);
        }
    }, [selectedCity]);

    return {cities, selectedCity, setSelectedCity, districts, setSelectedDistrict, selectedDistrict};
};

export default useCities;
